import { WindowCondition } from './components/WindowCondition';
import { OccurrencesCondition } from './components/OccurrencesCondition';
import { PurchaseCondition } from './components/PurchaseCondition';
import {
  OCCURRENCE_CONDITION_QUERY_KEY,
  PURCHASE_CONDITION_QUERY_KEY,
  WINDOW_CONDITION_QUERY_KEY,
} from './constants';

export const getOriginalId = (idText) => {
  // Checks if the given id is already in it's original form (does not contain an index at the end)
  // then returns the part without the index.
  const splitted = idText.split('_');
  const last = splitted.pop();
  return Number.isNaN(Number(last)) ? idText : splitted.join('_');
};

export const getComponentForCondition = (key) => {
  switch (key) {
    case WINDOW_CONDITION_QUERY_KEY:
      return WindowCondition;
    case PURCHASE_CONDITION_QUERY_KEY:
      return PurchaseCondition;
    case OCCURRENCE_CONDITION_QUERY_KEY:
      return OccurrencesCondition;
    default:
      return null;
  }
};

/** Check if query is loading existing data and get window value if so
 *  Only need to get from first or_clause since they should all have the same window
 */
export const getWindowValueFromQuery = (andQueries) => {
  if (andQueries.length > 0) {
    const orQueries = andQueries[0].or_clauses || [];
    if (orQueries.length > 0) {
      return orQueries[0].window;
    }
  }
  return null;
};
